import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Incident } from '../../models/incident';

@Component({
    selector: 'app-incident',
    templateUrl: './incident.html',
    styleUrl: './incident.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncidentComponent {
    incident = input.required<Incident>();
    inTimeline = input(false);
    notify = output<Incident>();

    capitalize(s: string): string {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    onIncidentClick(): void {
        this.notify.emit(this.incident());
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.notify.emit(this.incident());
        }
    }
}
